import React, { useState } from 'react';
import { Mail, User, MessageSquare, Send } from 'lucide-react';
import SEO from '../components/SEO';
import './Contact.css';

const Contact = () => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    message: ''
  });
  const [submitted, setSubmitted] = useState(false);

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    // Mock submission for frontend-only
    console.log('Form submitted (mock):', formData);
    setSubmitted(true);
    
    // Reset form after 3 seconds
    setTimeout(() => {
      setFormData({ name: '', email: '', message: '' });
      setSubmitted(false);
    }, 3000);
  };

  return (
    <div className="contact-page">
      <SEO
        title="Contact Us"
        description="Reach out to Cosmergence with questions, reflections, or to connect with our community. Form Cosmergent Circles and explore cosmic philosophy together."
        keywords="contact cosmergence, join cosmergence, cosmergent circles, philosophy community, spiritual community"
        canonicalUrl="/contact"
      />
      
      {/* Hero Section */}
      <section className="contact-hero cosmic-bg">
        <div className="container">
          <h1 className="heading-1 text-center">Contact Us</h1>
          <p className="body-large text-center" style={{maxWidth: '700px', margin: '24px auto 0'}}>
            Reach out with questions, reflections, or to connect with the Cosmergence community.
          </p>
        </div>
      </section>

      {/* Contact Form Section */}
      <section className="section-padding">
        <div className="container">
          <div className="contact-container">
            <div className="contact-info">
              <h2 className="heading-2 mb-4">Get in Touch</h2>
              <p className="body-regular" style={{marginBottom: '32px'}}>
                Whether you have questions about our philosophy, want to share your thoughts, or are interested in forming a Cosmergent Circle, we'd love to hear from you.
              </p>
              
              <div className="info-items">
                <div className="info-item">
                  <Mail size={24} className="text-gold" />
                  <div>
                    <p className="body-small text-muted">Email</p>
                    <p className="body-regular">hello@cosmergence.com</p>
                  </div>
                </div>
              </div>

              <div className="privacy-notice">
                <p className="body-small">
                  We only use your message to reply. Your information is never shared or stored beyond our response.
                </p>
              </div>
            </div>

            <div className="contact-form-wrapper">
              {submitted ? (
                <div className="success-message card">
                  <div className="success-icon">
                    <Send size={48} className="text-gold" />
                  </div>
                  <h3 className="heading-3">Message Sent</h3>
                  <p className="body-regular">
                    Thank you for reaching out. We'll respond soon.
                  </p>
                </div>
              ) : (
                <form onSubmit={handleSubmit} className="contact-form card">
                  <div className="form-group">
                    <label htmlFor="name" className="form-label">
                      <User size={18} />
                      Name
                    </label>
                    <input
                      type="text"
                      id="name"
                      name="name"
                      value={formData.name}
                      onChange={handleChange}
                      className="form-input"
                      required
                      placeholder="Your name"
                    />
                  </div>

                  <div className="form-group">
                    <label htmlFor="email" className="form-label">
                      <Mail size={18} />
                      Email
                    </label>
                    <input
                      type="email"
                      id="email"
                      name="email"
                      value={formData.email}
                      onChange={handleChange}
                      className="form-input"
                      required
                      placeholder="your@email.com"
                    />
                  </div>

                  <div className="form-group">
                    <label htmlFor="message" className="form-label">
                      <MessageSquare size={18} />
                      Message
                    </label>
                    <textarea
                      id="message"
                      name="message"
                      value={formData.message}
                      onChange={handleChange}
                      className="form-textarea"
                      required
                      placeholder="Share your thoughts..."
                      rows="6"
                    />
                  </div>

                  <button type="submit" className="btn-primary" style={{width: '100%'}}>
                    Send Message
                    <Send size={18} />
                  </button>
                </form>
              )}
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Contact;